import { isSafari, isIOS } from 'react-device-detect';
import { IMAGE_MIME_TYPES } from 'pages/Batch/configs';
import { getWebpSupport } from 'utils/images';
import type { BlobType, DownloadImageParams } from './types';

const isWebpSupported = getWebpSupport();

const ALPHA_CAPABLE_MIMES: ReadonlySet<string> = new Set([IMAGE_MIME_TYPES.PNG, IMAGE_MIME_TYPES.WEBP]);

export class AiService {
  static async downloadImage({ image, width, height, fileType, quality, sourceMime }: DownloadImageParams): Promise<BlobType> {
    const canvas: any = document.createElement('canvas');

    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');

    if (!ctx) {
      return null;
    }

    // Disable smoothing on all browsers
    ctx.imageSmoothingEnabled = false;
    ctx.msImageSmoothingEnabled = false;
    ctx.webkitImageSmoothingEnabled = false;

    ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);

    const isWebpFullySupported = isWebpSupported && !(isSafari || isIOS);

    let finalFileType = fileType;
    if (fileType === IMAGE_MIME_TYPES.WEBP && !isWebpFullySupported) {
      // On Safari/iOS WEBP encoding isn't reliable. Fall back to PNG when the source
      // may carry an alpha channel (PNG/WEBP) so transparency is preserved; otherwise
      // JPEG is fine and keeps file size down for plain photos.
      finalFileType = sourceMime && ALPHA_CAPABLE_MIMES.has(sourceMime) ? IMAGE_MIME_TYPES.PNG : IMAGE_MIME_TYPES.JPEG;
    }

    return new Promise(resolve => {
      canvas.toBlob((blob: Blob | null) => resolve(blob as BlobType), finalFileType, quality);
    });
  }
}
